import React from 'react'
import PropTypes from 'prop-types'

// Components
import ImageWrapper from './ImageWrapper'

// Utils
import { calculateHeightFromAspectRatio } from './utils'

/**
 * Standard Image - To be used for local imported files. No lazy loading, thumbs, or srcset.
 */
const StandardImage = (props) => {
  const {
    alt,
    aspectRatio,
    backgroundColor,
    height,
    imgClassName,
    imgStyle,
    objectFit,
    objectPosition,
    role,
    src,
    width,
    wrapperClassName,
    wrapperStyle,
  } = props

  // console.log('👾 StandardImage', props)
  return (
    <ImageWrapper
      alt={alt}
      aspectRatio={aspectRatio}
      backgroundColor={backgroundColor}
      height={height}
      objectFit={objectFit}
      objectPosition={objectPosition}
      role={role}
      wrapperClassName={wrapperClassName}
      wrapperStyle={wrapperStyle}
      width={width}
    >
      <img
        alt={role === 'presentation' ? '' : alt}
        className={`${imgClassName} standardImage`}
        draggable="false"
        height={calculateHeightFromAspectRatio(width, height, aspectRatio)}
        src={src}
        width={width}
        style={imgStyle}
      />
    </ImageWrapper>
  )
}

export default StandardImage

StandardImage.propTypes = {
  styles: PropTypes.string,
  src: PropTypes.string,
  image: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  alt: PropTypes.string.isRequired,
  role: PropTypes.string,
}

StandardImage.defaultProps = {
  alt: 'Fallback description',
  role: 'img',
}
